var _circle, _g, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_110_845)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_110_845_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.124 -0.124 0 129 129)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1008.06,
    y: -1008.06,
    width: 2016.13,
    height: 2016.13
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(49, 44, 163, 1) 0deg,rgba(54, 14, 105, 1) 112.92deg,rgba(255, 255, 255, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.8
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.19564837217330933,\"g\":0.17378471791744232,\"b\":0.64166665077209473,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.21422499418258667,\"g\":0.058437500149011612,\"b\":0.41249999403953552,\"a\":1.0},\"position\":0.31366547942161560},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.5185620230902253e-14,\"m01\":-248.0,\"m02\":253.0,\"m10\":248.0,\"m11\":1.5185620230902253e-14,\"m12\":5.0},\"opacity\":0.80000001192092896,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_110_845)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "#080722"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "url(#paint1_radial_110_845)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "url(#paint2_radial_110_845)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "url(#paint3_radial_110_845)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "url(#paint4_radial_110_845)",
    fillOpacity: 0.45
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_845",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 248,
    height: 248
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124,
    fill: "url(#paint5_radial_110_845)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_845)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter2_di_110_845)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2123 130.07C76.0497 132.125 72.4512 132.651 67.88 130.07H7.47998C7.47998 130.07 20.7497 128.488 37.2224 128.488C53.6951 128.488 59.1233 125.126 67.88 130.07H79.2123C91.5614 122.047 97.2632 90.718 128.28 130.07H167.776C173.072 119.499 178.257 108.018 187.765 107.917C196.676 107.823 206.525 128.488 217.05 128.488C227.574 128.488 249.08 130.07 249.08 130.07H167.776C159.837 145.918 151.651 159.722 128.28 130.07H79.2123Z",
    fill: "url(#paint6_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2123 130.07C76.0497 132.125 72.4512 132.651 67.88 130.07H7.47998C7.47998 130.07 20.7497 128.488 37.2224 128.488C53.6951 128.488 59.1233 125.126 67.88 130.07H79.2123C91.5614 122.047 97.2632 90.718 128.28 130.07H167.776C173.072 119.499 178.257 108.018 187.765 107.917C196.676 107.823 206.525 128.488 217.05 128.488C227.574 128.488 249.08 130.07 249.08 130.07H167.776C159.837 145.918 151.651 159.722 128.28 130.07H79.2123Z",
    fill: "url(#paint7_radial_110_845)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter3_dif_110_845)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.62 130.099C71.0722 121.05 74.4109 123.413 77.9043 130.099L117.365 130.099C146.36 16.1601 157.52 141.4 216.148 126.733C226.313 124.19 248.04 130.099 248.04 130.099L117.365 130.099C98.9181 202.588 87.7915 149.025 77.9043 130.099L67.62 130.099C54.3971 164.761 51.0444 130.099 34.6426 130.099H67.62Z",
    fill: "url(#paint8_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.62 130.099C71.0722 121.05 74.4109 123.413 77.9043 130.099L117.365 130.099C146.36 16.1601 157.52 141.4 216.148 126.733C226.313 124.19 248.04 130.099 248.04 130.099L117.365 130.099C98.9181 202.588 87.7915 149.025 77.9043 130.099L67.62 130.099C54.3971 164.761 51.0444 130.099 34.6426 130.099H67.62Z",
    fill: "url(#paint9_radial_110_845)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter4_di_110_845)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28 130.07C96.76 151.32 83.64 146.019 67.88 130.07H7.47998C7.47998 130.07 20.7497 128.487 37.2224 128.487C53.6951 128.487 52.12 114.12 67.88 130.07H128.28C161.946 107.372 180.613 128.487 217.05 128.487C227.574 128.487 249.08 130.07 249.08 130.07H128.28Z",
    fill: "url(#paint10_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28 130.07C96.76 151.32 83.64 146.019 67.88 130.07H7.47998C7.47998 130.07 20.7497 128.487 37.2224 128.487C53.6951 128.487 52.12 114.12 67.88 130.07H128.28C161.946 107.372 180.613 128.487 217.05 128.487C227.574 128.487 249.08 130.07 249.08 130.07H128.28Z",
    fill: "url(#paint11_radial_110_845)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter5_di_110_845)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.052 130.348C93.7537 149.18 79.7111 181.795 68.1049 130.348H24.9046C41.4387 130.348 49.797 49.1945 68.1049 130.348H107.052C114.73 119.474 122.16 113.195 128.73 130.348H225.28C229.144 129.777 233.281 129.731 237.733 130.348H249.98C249.98 130.348 297.476 138.628 237.734 130.348C237.734 130.348 237.733 130.348 237.733 130.348H225.28C177.29 137.438 171.441 225.498 128.73 130.348H107.052Z",
    fill: "url(#paint12_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.052 130.348C93.7537 149.18 79.7111 181.795 68.1049 130.348H24.9046C41.4387 130.348 49.797 49.1945 68.1049 130.348H107.052C114.73 119.474 122.16 113.195 128.73 130.348H225.28C229.144 129.777 233.281 129.731 237.733 130.348H249.98C249.98 130.348 297.476 138.628 237.734 130.348C237.734 130.348 237.733 130.348 237.733 130.348H225.28C177.29 137.438 171.441 225.498 128.73 130.348H107.052Z",
    fill: "url(#paint13_radial_110_845)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter6_di_110_845)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8 129C246.8 127.631 147.6 65.6288 89.32 135.069C31.04 204.509 5 125.151 5 126.52C5 126.966 12.44 126.52 28.56 126.52C58.2608 122.662 109.977 117.098 147.6 146.36C203.4 189.76 246.8 130.37 246.8 129Z",
    fill: "url(#paint14_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8 129C246.8 127.631 147.6 65.6288 89.32 135.069C31.04 204.509 5 125.151 5 126.52C5 126.966 12.44 126.52 28.56 126.52C58.2608 122.662 109.977 117.098 147.6 146.36C203.4 189.76 246.8 130.37 246.8 129Z",
    fill: "url(#paint15_radial_110_845)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter7_di_110_845)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253 129C253 130.37 169.92 131.48 129 131.48C88.08 131.48 5 130.37 5 129C5 127.631 59.56 110.4 129 126.52C198.44 142.64 253 127.631 253 129Z",
    fill: "url(#paint16_radial_110_845)",
    shapeRendering: "crispEdges"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253 129C253 130.37 169.92 131.48 129 131.48C88.08 131.48 5 130.37 5 129C5 127.631 59.56 110.4 129 126.52C198.44 142.64 253 127.631 253 129Z",
    fill: "url(#paint17_radial_110_845)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_110_845",
    x: 0,
    y: 0,
    width: 258,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_110_845"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_110_845_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 129,
    r: 124
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_110_845",
    x: 5,
    y: 5,
    width: 248,
    height: 248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.185021 0 0 0 0 0.156042 0 0 0 0 0.735625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_110_845"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2075 0 0 0 0 0.175 0 0 0 0 0.825 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_110_845",
    result: "effect2_innerShadow_110_845"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.791969 0 0 0 0 0.783437 0 0 0 0 0.954063 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_110_845",
    result: "effect3_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_110_845",
    x: -1.52002,
    y: 99.917,
    width: 259.6,
    height: 57.5918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.426944 0 0 0 0 0.966667 0 0 0 0 0.966667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900833 0 0 0 0 0.854167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dif_110_845",
    x: 25.6426,
    y: 73.771,
    width: 231.397,
    height: 103.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.426944 0 0 0 0 0.578067 0 0 0 0 0.966667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.416083 0 0 0 0 0.404167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_110_845",
    x: -1.52002,
    y: 111.555,
    width: 259.6,
    height: 42.5352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.664422 0 0 0 0 0.426944 0 0 0 0 0.966667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900833 0 0 0 0 0.854167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_110_845",
    x: 15.9047,
    y: 86.2798,
    width: 260.975,
    height: 97.9771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.664422 0 0 0 0 0.426944 0 0 0 0 0.966667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900833 0 0 0 0 0.854167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_110_845",
    x: -4,
    y: 94.2158,
    width: 259.8,
    height: 79.377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.664422 0 0 0 0 0.426944 0 0 0 0 0.966667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.416083 0 0 0 0 0.404167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_110_845",
    x: -4,
    y: 111.676,
    width: 266,
    height: 32.3682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.91225 0 0 0 0 0.6625 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_110_845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_110_845",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900833 0 0 0 0 0.854167 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_110_845"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.92 21.12) rotate(63.4457) scale(120.602 143.066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8AE6",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C25AD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.397 89.0124) rotate(151.458) scale(109.642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E36D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3029C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.089 246.397) rotate(-108.939) scale(79.1238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B54DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B55DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.48 129) rotate(-19.7672) scale(84.3291 125.666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D26B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453DD6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129 129) rotate(90) scale(124)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.351881,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.28 133.247) rotate(90) scale(22.3808 126.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.47998 137.366) scale(137.273 1845.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.76 118.924) rotate(90) scale(51.5774 126.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11195F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.47998 128.417) scale(136.682 4253.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.28 133.923) rotate(90) scale(11.0709 126.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.47998 135.96) scale(137.273 912.954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.73 137.008) rotate(90) scale(19.1361 127.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.47998 140.53) scale(137.784 1578.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129 141.586) rotate(-90) scale(3.00343 129.941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11195F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.99999 141.033) scale(140.909 247.677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.476 128.962) rotate(90) scale(1.09349 121.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2542DD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_110_845",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5 129.163) scale(131.223 90.1745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297404,
    stopColor: "#D1C1FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1C1FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.b4c5f65cbd93d59ef427253f1a29ed49.svg";
export { ForwardRef as ReactComponent };